import { css } from '@emotion/react';

import { SECONDARY_FONT_FAMILY, TERTIARY_FONT_FAMILY_HOS } from 'src/styles/constants';
import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    container: css({
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: '16px',
        width: '100%',
        maxWidth: 'none',

        [theme.breakpoints.up('md')]: {
            gridTemplateColumns: '1fr 1fr',
        },
    }),

    field: {
        '& .MuiOutlinedInput-root': {
            minHeight: '56px',
            borderRadius: '8px',
            backgroundColor: theme.palette.common.white,

            '& .MuiOutlinedInput-notchedOutline legend': {
                maxWidth: '0.01px',
            },

            '&.Mui-focused fieldset': {
                borderColor: theme.palette.primary.main,
                borderWidth: '1px',
            },

            '& .MuiSelect-select': {
                boxSizing: 'border-box',
                padding: '16.5px 14px',
                textAlign: 'left',
            },

            '& .MuiSelect-select[aria-disabled="true"]': {
                color: theme.palette.grey[500],
            },
        },

        '& .MuiInputLabel-root': {
            color: theme.palette.common.white,
            fontFamily: SECONDARY_FONT_FAMILY,
            fontSize: '15px',
            margin: '-15px 0 0 0',
            fontWeight: 700,
            lineHeight: '100%',
            letterSpacing: '0.03em',
            textTransform: 'uppercase',
            whiteSpace: 'nowrap',
        },

        '& .MuiInputLabel-root.Mui-focused': {
            color: theme.palette.primary.main,
        },
    },

    // HoS's paper colour is the same dark navy as its text, which hides the selectable days, so use the
    // light background its menus use instead
    calendarPaper: {
        ...(isHosTheme && {
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.primary,
        }),
    },

    durationField: {
        [theme.breakpoints.down('md')]: {
            margin: '15px 0 0 0',
        },
    },

    placeholder: css({
        color: theme.palette.grey[300],
        ...(isHosTheme && {
            fontFamily: TERTIARY_FONT_FAMILY_HOS,
        }),
    }),
};
